// extracted by mini-css-extract-plugin
export default {"mobileBlocker":"MobileBlocker_mobileBlocker__E+WDF","mobileBlockerContent":"MobileBlocker_mobileBlockerContent__eSJ3n","offButton":"MobileBlocker_offButton__KprK8"};